import TelegramPage from './TelegramPage';

export default TelegramPage;
